/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { StepCodes } from './step-codes';
import { StepConfigModel } from '@models/wizard/steps-config.model';

/**
 * L'oggetto configura per ogni step code il path della pagina da visualizzare.
 *
 * Il comportamento di default compone il path finale nel seguente modo
 *  "position/<path>"
 * Se è necessario definire un path diverso è possibile mettere a true
 * la proprietà "absolutePath", in questo modo il path finale terrà conto
 * esclusivamente di quanto dichirato nella proprietà "path"
 */

export const STEPS_CONFIG: {
  [stepCode: string]: StepConfigModel;
} = {
  [StepCodes.consents]: { path: 'consents' },
  [StepCodes.documentsRequest]: { path: 'documents-request' },
  [StepCodes.documentsView]: { path: 'documents-view' },
  [StepCodes.additionalDocumentsRequest]: { path: 'documents-request' },
  [StepCodes.resolution]: { path: 'delivery-data' },
  [StepCodes.quotation]: { path: 'quotation' },
  [StepCodes.obligations]: { path: 'obligations' },
  [StepCodes.recognition]: { path: 'recognition' },
  [StepCodes.adequacy]: { path: 'adequacy' },
  [StepCodes.contractSigning]: { path: 'contract-signing' },
  [StepCodes.notes]: { path: 'notes' }
};
